import { gql } from '@apollo/client';

export const GET_IMAGE = gql`
    query GetImage($id: ID!) {
        preloadedImage(id: $id) {
            url
        }
    }
`;

export const GET_VERBATIM = gql`
    query GetVerbatim($id: ID!) {
        verbatim(id: $id) {
            author
            body
        }
    }
`;

export const GET_ARTICLE = gql`
    query GetArticle($id: ID!) {
        article(id: $id) {
            heading
            subheading
            body
            bodyHTML
        }
    }
`;

export const GET_PAYMENT = gql`
    query GetPayment($id: ID!) {
        payment(id: $id) {
            id
            heading
            subheading
            descriptionHTML
            price
            url
            label
        }
    }
`;

export const GET_ILLUSTRATED_PAYMENT = gql`
    query GetIllustratedPayment($imageId: ID!, $paymentId: ID!) {
        preloadedImage(id: $imageId) {
            url
        }
        payment(id: $paymentId) {
            id
            heading
            subheading
            descriptionHTML
            price
            url
            label
        }
    }
`;

export const GET_ILLUSTRATED_CTA = gql`
    query GetIllustratedCTA($ctaId: ID!, $imageId: ID!) {
        preloadedImage(id: $imageId) {
            url
        }
        cta(id: $ctaId) {
            id
            label
            link
            bodyHTML
        }
    }
`;

export const GET_PAYMENTS = gql`
    query GetPayments($order: [ID]!) {
        payments(order: $order) {
            id
            heading
            subheading
            descriptionHTML
            price
            url
            label
        }
    }
`;

export const GET_NEWSLETTER_SIGN_UP = gql`
    query GetNewsletterSignUp($id: ID!, $imageId: ID!, $locale: String!) {
        preloadedImage(id: $imageId) {
            url
        }
        newsletterSignUp(id: $id, locale: $locale) {
            heading
            body
        }
    }
`;

export const GET_NEWSLETTER_RECIPIENT = gql`
    query GetNewsletterRecipient($path: String!, $id: ID!) {
        newsletterRecipient(path: $path, id: $id) {
            firstName
            email
        }
    }
`;

export const NEWSLETTER_RECIPIENT_EXISTS = gql`
    query GetNewsletterRecipientExists($path: String!, $email: String!) {
        newsletterRecipientExists(path: $path, email: $email)
    }
`;